import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import LanguageSettings from './LanguageSettings';
import Domains from './Domains';
import { VoiceAgent } from './VoiceAgent';
import AvatarSetting from './AvatarSetting';
import $ from 'jquery';

class BasciSettingsTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/projectmgmt";
      var path1 = window.origin + "/platform/projectmgmt/";
      if (currentPath === path || currentPath === path1) {
        $("#language").addClass('active');
      } else if (currentPath.includes("/projectmgmt/domain")) {
        $("#domain-tab").addClass('active');
      } else if (currentPath.includes("/projectmgmt/voice") || currentPath.includes("/projectmgmt/voice/")) {
        $("#voice").addClass('active');
      } else if (currentPath.includes("/projectmgmt/avatar-settings")) {
        $("#avatar-settings").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#language,#domain-tab,#voice,#avatar-settings,#bot-store")
        .on("click", function () {
          $("#language,#domain-tab,#voice,#avatar-settings,#bot-store")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })
    })();
  }
  render() {
    return (
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <div className="container-fluid" style={{ marginLeft: '10px' }}>
            {/* Nav tabs */}
            <div className="tab-class" >
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link to="/projectmgmt" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="language">Language</li>
                </Link>
                <Link to="/projectmgmt/domain" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="domain-tab">Domain</li>
                </Link>
                <Link to="/projectmgmt/voice" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="voice">Voice</li>
                </Link>
                <Link to="/projectmgmt/avatar-settings" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="avatar-settings">Avatar Settings</li>
                </Link>

              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/avatar-settings" component={AvatarSetting}></Route>
          <Route path="/projectmgmt/voice" component={VoiceAgent}></Route>
          <Route path="/projectmgmt/domain" component={Domains}></Route>
          <Route path="/projectmgmt" component={LanguageSettings}></Route>
        </Switch>
      </div>
    );
  }
}
export default BasciSettingsTab;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/BasciSettingsTab.js